//src/components/shared/EmptyState.tsx
import { LucideIcon, FileQuestion } from "lucide-react";

import { Button } from "@/components/ui/button";
import { PermissionButton } from "@/components/shared/PermissionButton";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  actionLabel?: string;
  actionPermission?: string;
  onAction?: () => void;
}

export function EmptyState({
  icon: Icon = FileQuestion,
  title,
  description,
  actionLabel,
  actionPermission,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
        <Icon className="h-8 w-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold">{title}</h3>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>
      )}
      {actionLabel && onAction && actionPermission ? (
        <PermissionButton className="mt-4" permission={actionPermission} onClick={onAction}>
          {actionLabel}
        </PermissionButton>
      ) : actionLabel && onAction ? (
        <Button className="mt-4" onClick={onAction}>{actionLabel}</Button>
      ) : null}
    </div>
  );
}
